import General from './General.vue';

export default General;
